import React, { useState } from 'react';
import { connect } from "react-redux";

import LoginPage from './LoginPage';
import { useLogin } from './AuthUserContext';

const LoginPageContainer = ({
}) => {
  const login = useLogin();
  const [ data, setData ] = useState({ emailAddress: "", password: "" });

  const handleChange = e => {
    setData({...data, [e.target.name]: e.target.value});
  };

  const handleSubmit = e => {
    e.preventDefault();
    const emailAddress = data.emailAddress;
    const password = data.password;

    if (emailAddress !== "" && password !== "")
      login(emailAddress, password);

    e.target.reset();
  };

  return (
    <LoginPage
      handleChange={handleChange}
      handleSubmit={handleSubmit}
    />
  );
}

const mapStateToProps = state => ({
});

export default connect(mapStateToProps)(LoginPageContainer);
